module.exports = __webpack_public_path__ + "img/icon67.6087fc9d.png";